// src/pages/Home.js
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { useParams, useNavigate } from 'react-router-dom';
import TellFriend from '../../components/TellFriend';

const CheckCircleIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    width="1em"
    height="1em"
    aria-hidden="true"
    style={{ display: 'inline-block' }}
    className="single-point-icon"
  >
    <path
      fill="currentColor"
      d="M0 256C0 114.6 114.6 0 256 0C397.4 0 512 114.6 512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256zM371.8 211.8C382.7 200.9 382.7 183.1 371.8 172.2C360.9 161.3 343.1 161.3 332.2 172.2L224 280.4L179.8 236.2C168.9 225.3 151.1 225.3 140.2 236.2C129.3 247.1 129.3 264.9 140.2 275.8L204.2 339.8C215.1 350.7 232.9 350.7 243.8 339.8L371.8 211.8z"
    />
  </svg>
);

const Home = () => {
  const { agent_name = '', id = '' } = useParams();
  const navigate = useNavigate();
  // useEffect(() => {

  //   // removeSession();
  // }, []);

  useEffect(() => {
    if (agent_name && id) {
      localStorage.setItem('join_agent_name', agent_name);
      localStorage.setItem('join_id', id);
    }
  }, [agent_name, id]);

  useEffect(() => {
    const storedAgentName = localStorage.getItem('join_agent_name');
    const storedId = localStorage.getItem('join_id');
    if ((!agent_name || !id) && storedAgentName && storedId) {
      navigate(`/rep/${storedAgentName}/${storedId}`, { replace: true });
    }
  }, [agent_name, id, navigate]);

  return (
    <>
      <Helmet>
        <title>Surity Select — Insurance &amp; Membership Benefits</title>
        <meta charset="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta
          name="description"
          content="Surity Select offers health, dental, life, and disability insurance plans plus exclusive membership benefits including free Surity Essentials."
        />
        <meta name="author" content="Surity Select" />
      </Helmet>
      <div className="banner-section">
        <div className="container">
          <div className="row banner-wrapper">
            <div className="col-lg-7 col-md-8">
              <div className="banner-left">
                <h1>
                  <span className="d-block">Shop for benefits.</span>
                  <span className="d-block">Save with membership.</span>
                </h1>
                <p className='banner-left-h2'>Welcome to a fresh new way of looking after your health, wealth and finances.</p>
              </div>
            </div>
            <div className="col-lg-5 col-md-4 position-relative">
              <div className="main-banner-right">
                <img
                  src="https://imgcdn.kuick.com/surity-select/home-woman-desktop.png"
                  className="main-banner-img wow fadeInRight"
                  alt="A Surity Select member enjoying financial peace of mind"
                  fetchpriority="high"
                  width="516"
                  height="509"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="benefits">
        <div className="container">
          <h2 className="ben-header wow fadeIn" data-wow-delay="0.1s">
            Why Become a Surity Select Member?
          </h2>
          <p className="ben-subheader wow fadeIn mb-0 w-100 strong" data-wow-delay="0.2s">
            Because you’re tired of surprises when it comes to your benefits, paycheck and taxes.
          </p>
          <p className="ben-subheader wow fadeIn w-100 strong" data-wow-delay="0.3s">
            And, you get the wildly popular Surity Essentials for FREE!
          </p>

          <div className="row main-page justify-content-center">
            <div className="col-lg-4 col-md-6">
              <div className="single-features-surity wow fadeInRight" data-wow-delay="0.1s">
                <span className="sfs-heading roboto">FREE</span>
                <h3 className="sfs-heading-2 roboto">Surity Essentials</h3>
                <p className="sfs-body">
                  Identity Theft Protection,
                  <br />
                  Lawyers at a Big Discount,
                  <br />
                  Protection Online via VPN,
                  <br />
                  FREE Tax Preparation,
                  <br />
                  FREE Simple Will
                  <br />
                  ...and SO much more!
                </p>
                <p>
                  <Link
                    to="/membership" // Use a leading slash for absolute paths
                    className="theme-btn wow zoomIn"
                    data-wow-delay="0.6s"
                  >
                    DISCOVER MORE
                  </Link>
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="single-features-surity wow fadeInUp" data-wow-delay="0.1s">
                <span className="sfs-heading roboto">SAVE ON</span>
                <h3 className="sfs-heading-2 roboto">The Strategizer</h3>
                <p className="sfs-body">
                  Boost the performance of your paycheck. The Strategizer coordinates your benefits,
                  taxes, and retirement, giving you a workable plan. It's an annual checkup for your
                  paycheck.
                </p>
                <p>
                  <Link
                    to="/strategizer" // Use a leading slash for absolute paths
                    className="theme-btn wow zoomIn"
                    data-wow-delay="0.6s"
                  >
                    DISCOVER MORE
                  </Link>
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="single-features-surity wow fadeInLeft" data-wow-delay="0.1s">
                <span className="sfs-heading roboto">EXCLUSIVE</span>
                <h3 className="sfs-heading-2 roboto">Surity Care</h3>
                <p className="sfs-body">
                  Surity Care eliminates copays and so much more for those with or without medical
                  insurance. It's also perfect for those who are part of a medical share group.
                </p>
                <p>
                  <Link
                    to="/surity-care" // Use a leading slash for absolute paths
                    className="theme-btn wow zoomIn"
                    data-wow-delay="0.6s"
                  >
                    DISCOVER MORE
                  </Link>
                </p>
              </div>
            </div>
          </div>

          <div className="row mt-4">
            <div className="col-md-12">
              <p className="ben-header text-1 wow fadeIn rsk" data-wow-delay="0.1s">
                Plus, previously exclusive to the corporate world, these benefits are now available
                to Surity Select members!
              </p>
              <p className="ben-subheader wow fadeIn rsk mb-5" data-wow-delay="0.2s">
                Shop these and other world class benefits from big names you'll recognize. When you
                become a Surity Select Member, it's easy and some benefits are even discounted.
              </p>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-1 col-md-0"></div>
            <div className="col-lg-10 col-md-12">
              <div className="row">
                <div className="col-md-4">
                  <Link
                    to="/accident-insurance" // Use a leading slash for absolute paths
                    className="theme-btn-2 wow fadeInUp"
                    data-wow-delay="0.1s"
                  >
                    Accident
                  </Link>
                  <Link
                    to="/cancer-insurance-why" // Use a leading slash for absolute paths
                    className="theme-btn-2 wow fadeInUp"
                    data-wow-delay="0.2s"
                  >
                    Cancer
                  </Link>
                  <Link
                    to="/disability-insurance" // Use a leading slash for absolute paths
                    className="theme-btn-2 wow fadeInUp"
                    data-wow-delay="0.3s"
                  >
                    Disability
                  </Link>
                </div>
                <div className="col-md-4">
                  <Link
                    to="/pet-insurance" // Use a leading slash for absolute paths
                    className="theme-btn-2 wow fadeInUp"
                    data-wow-delay="0.4s"
                  >
                    Pet
                  </Link>
                  <Link
                    to="/medical-gap" // Use a leading slash for absolute paths
                    className="theme-btn-2 wow fadeInUp"
                    data-wow-delay="0.5s"
                  >
                    Medical / Gap
                  </Link>
                  <Link
                    to="/life-mortgage-insurance" // Use a leading slash for absolute paths
                    className="theme-btn-2 wow fadeInUp"
                    data-wow-delay="0.6s"
                  >
                    Life / Mortgage
                  </Link>
                </div>
                <div className="col-md-4">
                  <Link
                    to="/dental-insurance-why" // Use a leading slash for absolute paths
                    className="theme-btn-2 wow fadeInUp"
                    data-wow-delay="0.7s"
                  >
                    Dental / Vision
                  </Link>
                  <Link
                    to="/critical-illness" // Use a leading slash for absolute paths
                    className="theme-btn-2 wow fadeInUp"
                    data-wow-delay="0.8s"
                  >
                    Critical Illness
                  </Link>
                  <Link
                    to="/product-plans#retireePlans" // Use a leading slash for absolute paths and include the hash
                    className="theme-btn-2 wow fadeInUp"
                    data-wow-delay="0.9s"
                  >
                    Retiree Plans
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-lg-1 col-md-0"></div>
          </div>

          <p className="text-center mt-5">
            <Link
              to="/membership" // Use a leading slash for absolute paths
              className="theme-btn wow zoomIn"
              data-wow-delay="0.6s"
            >
              MEMBERSHIP
            </Link>
          </p>
        </div>
      </div>

      <div className="surity-plans pt-0">
        <div className="container">
          <div className="row">
            <h2 className="text-center mb-4">Surity Select Plans Offer:</h2>
            <div className="row">
              <div className="col">
                <div className="single-point wow fadeInUp" data-wow-delay="0.1s">
                  <CheckCircleIcon />
                  <p>World Class</p>
                  <p>Benefits</p>
                </div>
              </div>
              <div className="col">
                <div className="single-point wow fadeInUp" data-wow-delay="0.3s">
                  <CheckCircleIcon />
                  <p>Little or</p>
                  <p>No Medical</p>
                  <p>Questions</p>
                </div>
              </div>
              <div className="col">
                <div className="single-point wow fadeInUp" data-wow-delay="0.5s">
                  <CheckCircleIcon />
                  <p>Enroll</p>
                  <p>24/7/365</p>
                </div>
              </div>
              <div className="col">
                <div className="single-point wow fadeInUp" data-wow-delay="0.7s">
                  <CheckCircleIcon />
                  <p>Quick to Buy</p>
                  <p>Easy to Use</p>
                </div>
              </div>
              <div className="col">
                <div className="single-point wow fadeInUp" data-wow-delay="0.9s">
                  <CheckCircleIcon />
                  <p>Personalized</p>
                  <p>Dashboard</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <TellFriend />
    </>
  );
};

export default Home;
